<ng-container *ngIf="kioskDisabled; else kioskLogin">
    <div class="alert alert-warning">This kiosk mode is currently disabled. You will be redirected to the home page in 5 seconds...</div>
</ng-container>
<ng-template #kioskLogin>
    <div class="d-flex justify-content-center align-items-center">
        <div *ngIf="isLoading" class="overlay">
            <div class="spinner-border text-primary m-2" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div class="card col-sm-12 col-md-5 border border-primary rounded">
            <div class="card-body flex-column">
                <p class="text-center"><img [src]="companyConfig?.logoUrl" alt="" class="company-logo" /></p>
                <quill-view [content]="welcomeText" style="margin-top:10px; margin-bottom:10px"></quill-view>
                <form [formGroup]="loginForm" (ngSubmit)="clockinout()" class="w-100 h-100 mt-2">
                    <div *ngIf="companyConfig?.isCompanySelection" class="m-2">
                        <app-company-input [isDropdown]="companyConfig?.isCoDropdownVisible"
                                           [companies]="companyConfig?.coDropdownCompanies"
                                           formControlName="companySelect"
                                           (change)="updateCompanyLogo($event)">
                        </app-company-input>
                    </div>
                    <div class="m-2">
                        <label for="employee-num">Employee Number<span class="text-danger font-weight-bolder h3"> *</span></label>
                        <input #employeeNum type="number" class="form-control" id="employee-num" name="employee-num" formControlName="employeeNum" />
                    </div>
                    <div class="m-2">
                        <app-password-input formControlName="password"></app-password-input>
                    </div>
                    <div class="m-2 mt-3 mb-3">
                        <button [disabled]="loginForm.invalid" class="btn btn-primary w-100" type="submit">CLOCK IN/OUT</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>
<app-login-footer></app-login-footer>
